<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<span class="x-ebookmaker-pageno" id="Page_0"></span>
<figure class="figcenter illowe28_125" id="i_frontispiece">
<img alt="Object—matrimony" class="w100" id="img_images_i_frontispiece.jpg" src="3624747857925452935_i_frontispiece.jpg"/>
<figcaption class="caption"><p class="caption">“Object—matrimony,” he retorted.</p>
<p class="right">[<span class="smcap">Page <a class="pginternal" href="#/3186253215635795556_74210h15.htm#Page_168">168</a></span>]</p></figcaption>
</figure>
</div>
<div class="titlepage">
<p><span class="xxlarge"><i>The</i><br/>
MOVING FINGER</span></p>
<p>BY<br/>
<span class="xlarge">NATALIE SUMNER LINCOLN</span><br/>
<br/>
<span class="small">AUTHOR OF “THE NAMELESS MAN,” “I SPY,” “C. O. D.,”<br/>
“THE LOST DESPATCH,” “THE TREVOR CASE,” ETC.</span></p>
<div class="figcenter"><img alt="publisher's logo" id="img_images_i_logo.jpg" src="3624747857925452935_i_logo.jpg"/></div>
<p><span class="small">ILLUSTRATED BY</span><br/>
CHARLES L. WRENN</p>
<p><span class="large">D. APPLETON AND COMPANY</span><br/>
NEW YORK  <span class="gap">    LONDON</span><br/>
1918</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 3186253215635795556_74210-h-2.htm.vue?dd798294